var WindowReferenceService = /** @class */ (function () {
    function WindowReferenceService() {
    }
    Object.defineProperty(WindowReferenceService.prototype, "window", {
        // noinspection JSMethodCanBeStatic
        get: function () {
            return window;
        },
        enumerable: true,
        configurable: true
    });
    return WindowReferenceService;
}());
export { WindowReferenceService };
